    document.addEventListener("DOMContentLoaded", function () {
  ScrollReveal().reveal('[data-template="index"] .shopify-section', {
    delay: 500,
    origin: 'bottom',
       distance: '40px',
    duration: 1000,
  });
    ScrollReveal().reveal('[data-template="collection"] h1 , [data-template="collection"] h2' , {
    delay: 500,
    origin: 'bottom',
    duration: 1000,
  });
   ScrollReveal().reveal('h2', {
    delay: 500,
    distance: '40px',
    origin: 'bottom',
    duration: 1000,
  });
      ScrollReveal().reveal('[data-template="list-collections"] h1 , [data-template="list-collections"] h2', {
    delay: 500,
    origin: 'bottom',
    duration: 1000,
  });
  ScrollReveal().reveal('.resource-list__item ,.service-item,.social-icons__wrapper .social-icons__icon-wrapper ', {
    delay: 300,
    distance: '40px',
    origin: 'bottom',
    duration: 800,
    interval: 200 // ← أهم سطر (التوالي)
});
  ScrollReveal().reveal('.product-card', {
    delay: 300,
    distance: '40px',
    origin: 'bottom',
    duration: 800,
    interval: 200 // ← أهم سطر (التوالي)
});
ScrollReveal().reveal('footer h2 , footer p',{
    delay: 300,
 duration: 800
});
});
console.log("hello");

